module.exports = __webpack_public_path__ + "img/rukhsary-altwny.fce4fa14.webp";